import { api } from "./api";

export async function getBillOfSaleDocument(artworkId) {
  return api.getJson(`/agreements/bill-of-sale/document/?artwork_id=${encodeURIComponent(artworkId)}`);
}

export async function acceptBillOfSale(artworkId, context = {}) {
  return api.postJson("/agreements/bill-of-sale/accept/", {
    artwork_id: artworkId,
    context,
  });
}
